export interface IEnvironment {
  name: string;
  prod: string;
  uat: string;
  uatDate: string;
  prodDate: string;
  rm: string;
  isoCode: string;
  isLive: boolean;
  priority: number;
  url?: string;
  additionalDomains?: string[];
  cluster?: string;
}

export interface IChangelogRecord {
  id: string;
  description: string;
  tags: string[];
}

export enum EnvType {
  prod = "prd",
  uat = "uat",
  internal = "internal",
}

export type FilterFnType = (
  firstEnv: IEnvironment,
  secondEnv: IEnvironment
) => number;
